const getQueryParams = (url: string): Record<string, string> => {
  const params: Record<string, string> = {};
  const searchParams = new URL(url).searchParams;

  searchParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
};

export { getQueryParams };
